import { createSelector } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { getFirstLastNameObj } from '../../utils/format';
import { EmployeeDto } from '@api/models/employees/EmployeeDto';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { EntityState } from '@api/models/enums/EntityState';
import { UserRole } from '@api/models/enums/UserRole';
import { employeeService } from '@api/services/services';

type State = BaseType<EmployeeDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsEmployeeSlice = baseSlice({
  name: 'optionsEmployee',
  initialState,
});

export const selectOptionsEmployeeState = (state: RootState) => state.optionsEmployee.state;
export const selectOptionsEmployee = createSelector(
  (state: RootState) => state.optionsEmployee.data,
  (data) => data.map((x) => ({ id: x.id, name: getFirstLastNameObj(x) }) as ReferenceDto),
);
export const optionsEmployeeActions = optionsEmployeeSlice.actions;

export const getOptionsEmployee =
  (filterOutNonHumanRoles: boolean | undefined, search: string | undefined, cancelToken: CancelToken, roles?: UserRole[]) =>
  (dispatch: AppDispatch) => {
    const handleGetData = async () => {
      const response = await employeeService.query(
        {
          q: search,
          state: EntityState.Active,
          filterOutNonHumanRoles: filterOutNonHumanRoles,
          roles,
          page: 0,
          size: AUTOCOMPLETE_MAX_ITEMS,
          sort: ['name', 'asc'],
        },
        { cancelToken: cancelToken },
      );
      return { data: response.data.content ?? [] };
    };

    getItem({
      dispatch,
      actions: optionsEmployeeActions,
      getData: handleGetData,
    });
  };
